import { apiPost } from './api';

const SERVICE_BASE_URL = process.env.REACT_APP_SERVICE_BASE_URL || '';
function buildUrl(url) {
  if (SERVICE_BASE_URL && url.startsWith('/')) return `${SERVICE_BASE_URL}${url}`;
  return url;
}

export async function getInvitation(token) {
  const response = await fetch(buildUrl(`/api/Invitations/${encodeURIComponent(token)}`), {
    credentials: 'include',
  });
  if (response.ok) {
    return { ok: true, data: await response.json() };
  }
  let error = 'Invitation not found.';
  try {
    const body = await response.json();
    if (body?.error) error = body.error;
  } catch { /* ignore */ }
  return { ok: false, error };
}

export function acceptInvitation(token, password) {
  return apiPost(`/api/Invitations/${encodeURIComponent(token)}/accept`, { password });
}
